import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The General tab body (SWOOP-254 US1), rendered inside the work-order page layout at
 * `/work-orders/$workOrderId`. Permission / module gating is inherited from the layout route's
 * `beforeLoad`. `dynamic` because the page titles the browser tab with the work order number (the layout
 * already does, so this tab adds no static title).
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId/')({
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-general-tab')),
  staticData: { dynamic: true },
});
